import axios from '@/utils/AxiosConfig';

export default {
  async all(sort_by) {
    return axios.api.get(`/contributors?sortBy=${sort_by}`);
  },
  async contributor(contributor) {
    return axios.api.get(`/contributors/${contributor}`);
  },
  async popular(type = 'vote', limit = 5) {
    return axios.api.get(`/contributors/popular?sortBy=${type}&limit=${limit}`);
  },
  async businesses(contributor, sortBy, orderBy) {
    return axios.api.get(`/contributors/${contributor}/businesses?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async businessesForSector(contributor, sector, sortBy, orderBy) {
    return axios.api.get(`/contributors/${contributor}/businesses/sectors/${sector}?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async businessesForCategory(contributor,sector, category, sortBy, orderBy) {
    return axios.api.get(`/contributors/${contributor}/businesses/sectors/${sector}/categories/${category}?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async business(contributor, sector, category, business) {
    return axios.api.get(`/contributors/${contributor}/businesses/sectors/${sector}/categories/${category}/${business}`);
  },
  similarBusinesses: async (contributor,business, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/${business}/related?limit=${limit}`),
  topRatedBusinesses: async (contributor, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/top-rated?limit=${limit}`),
  mostVotedBusinesses: async (contributor,limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/popular?limit=${limit}`),
  topRatedBusinessesBySector: async (contributor, sector, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/sectors/${sector}/top-rated?limit=${limit}`),
  mostVotedBusinessesBySector: async (contributor, sector, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/sectors/${sector}/popular?limit=${limit}`),
  topRatedBusinessesByCategory: async (contributor, category, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/categories/${category}/top-rated?limit=${limit}`),
  mostVotedBusinessesByCategory: async (contributor, category, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/categories/${category}/popular?limit=${limit}`),
  constructContributor: (contributor) => ({
    id: contributor.id,
    type: contributor.type,
    ...contributor.attributes,
    profile: {
      id: contributor.relationships.profile.id,
      type: contributor.relationships.profile.type,
      ...contributor.relationships.profile.attributes
    }
  })
};
